import { rentVerificationApi } from 'src/api';
import { getPaginationRequest } from 'src/ts/interfaces';

const api = {
  getAll({ page, rowsPerPage, filter, sort, q }: getPaginationRequest) {
    const pageNum = page?.toString();
    const rowsPerPageNum = rowsPerPage?.toString();
    return rentVerificationApi.getRentVerifications(pageNum, rowsPerPageNum, filter, sort, q);
  }
};

export default api;
